import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react"

function WordsLine(
    {
        words = []
    }
){
    return (
        <div className="min-w-full text-[5dvw] mobile:text-[6dvw] font-bold flex justify-around">
            {words.map(word=>
                <span className="text-[rgba(0,0,0,0.3)]">
                    #{word}
                </span>
            )}
        </div>
    )
}

export default function WordsAutoSlider(
    {
        words = []
    }
){
    const ref = useRef(null);
    useGSAP(()=>{
        gsap.to(ref.current,{
            xPercent: -100,
            ease: "linear",
            repeat: -1,
            duration: 20
        })
    })
    return (
        <div className="w-full overflow-hidden">
            <div ref={ref} className="flex items-center min-w-full">
                <WordsLine words={words}/>
                <WordsLine words={words}/>
            </div>
        </div>
    )
}